import React, { useEffect, useState } from 'react'
import { updateShowSideModal, updateUser, useReturnUserSideModalStatus } from './userSlice'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../app/hooks'
import { Avatar, Button, IconButton } from '@mui/material'
import GenerateIcon, { IconTypes } from '../../components/GenerateIcon'
import { Link, useLocation } from 'react-router-dom'
import UsersApp from './UsersApp'
import { IUserModel, UserTheme } from '../../services/user'
import { error } from 'console'
import { handleRequestError } from '../../services/api'

interface IUserMenuItem {
    id: string,
    icon: IconTypes,
    title: string,
    link: string,
    isAdminOnly?: boolean,
}

export default function UserSideModal() {

    const dispatch = useDispatch()
    const location = useLocation()

    const open = useReturnUserSideModalStatus()
    const user = useAppSelector((state) => state.user.details)

    const usersApp = new UsersApp()

    const [loadingTheme, setLoadingTheme] = useState<boolean>(false)

    const baseContainerClassName: string = "user-sidebar-modal-container"
    const [containerClassName, setContainerClassName] = useState<string>(baseContainerClassName)

    const [menuItems, setMenuItems] = useState<IUserMenuItem[]>([])

    const addMenuItem = (item: IUserMenuItem) => {
        if (menuItems.filter(singleItem => singleItem.id === item.id).length === 0){
            setMenuItems([
                ...menuItems,
                {
                    ...item
                }
            ])
        }
    }

    /**
     * Handle close
     */
    const handleClose = () => dispatch(updateShowSideModal(false))

    useEffect(() => {
        if (open){
            setContainerClassName(baseContainerClassName + " active")
        }else{
            setContainerClassName(baseContainerClassName)
        }
    }, [open])

    /**
     * Menu items
     */
    useEffect(() => {

        setMenuItems([
            {
                id: "home",
                icon: "home",
                title: "Home",
                link: "/"
            },
            {
                id: "admin",
                icon: "admin",
                title: "Admin Panel",
                link: "/panel/dashboard",
                isAdminOnly: true
            },
            {
                id: "profile",
                icon: "profile",
                title: "Profile",
                link: "/profile"
            },
            {
                id: "security",
                icon: "security",
                title: "Security",
                link: "/profile/security"
            },
            {
                id: "two-factor-auth",
                icon: "lock",
                title: "2F Authentication ",
                link: "/profile/two-factor-auth"
            },
        ])

    }, [user])

    useEffect(() => {
        dispatch(updateShowSideModal(false))
    }, [location.pathname])

    /**
     * Handle update theme
     */
    const handleUpdateUserTheme = (theme: UserTheme) => {
        setLoadingTheme(true)

        usersApp.updateTheme(theme)
            .then(response => {

                const { data } = response
                const userDetails: IUserModel = data.user

                dispatch(updateUser(userDetails))
                setLoadingTheme(false)

            })
            .catch(error => {
                setLoadingTheme(false)
                handleRequestError(error, dispatch)
            })
    }

    return(
        <div className="wrapper-of-user-sidebar-modal-container">
            <div className={containerClassName}>
                <div className="content-of-user-sidebar-modal-container">

                    <div className="close-user-sidebar-modal-container-box">
                        <div className="content-of-close-user-sidebar-modal-container-box">
                            <IconButton onClick={() => handleClose()}>
                                <GenerateIcon icon="close" />
                            </IconButton>
                        </div>
                    </div>

                    <div className="main-content-of-user-sidebar-modal-container">
                        <div className="content-of-main-content-of-user-sidebar-modal-container">

                            <div className="avatar-section-of-user-sidebar-modal-container">
                                <div className="content-of-avatar-section-of-user-sidebar-modal-container">

                                    <Avatar src={user.thumbnail}><GenerateIcon icon="user" /></Avatar>

                                    <h3>{user.full_name}</h3>
                                    <p>{user.email}</p>

                                </div>
                            </div>

                            <div className="menu-of-user-sidebar-modal-container">
                                <div className="content-of-menu-of-user-sidebar-modal-container">
                                    {menuItems.map((item, index) => {

                                        if (item.isAdminOnly){
                                            if (!user.is_superuser){
                                                return <></>
                                            }
                                        }

                                        return(
                                            <Link to={item.link} key={index}>
                                                <div className="single-menu-item-of-sidebar-modal-container">
                                                    <div className="content-of-single-menu-item-of-sidebar-modal-container">
                                                        <div className="icon-of-single-menu-item-of-sidebar-modal-container">
                                                            <GenerateIcon icon={item.icon} />
                                                        </div>
                                                        <p>{item.title}</p>
                                                    </div>
                                                </div>
                                            </Link>
                                        )
                                    })}

                                    <div className="single-menu-item-of-sidebar-modal-container" onClick={() => handleUpdateUserTheme(user.theme === "light" ? "dark" : "light")}>
                                        <div className="content-of-single-menu-item-of-sidebar-modal-container">
                                            <div className="icon-of-single-menu-item-of-sidebar-modal-container">
                                                <GenerateIcon icon={user.theme === "dark" ? "light-mode" : "dark-mode"} />
                                            </div>
                                            <p>{user.theme === "dark" ? "Light Mode" : "Dark Mode"}</p>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="action-container-of-user-sidebar-modal-container">
                        <div className="content-of-action-container-of-user-sidebar-modal-container">
                            <Button href="/logout" fullWidth color="error" className="general-button admin-style light-button">Logout</Button>
                        </div>
                    </div>

                </div>
            </div>

            <div className={open ? "mask-of-user-sidebar-modal-container active" : "mask-of-user-sidebar-modal-container"} onClick={() => handleClose()}></div>
        </div>
    )
}